import React, { useState, useRef } from "react";
import { Sheet } from "react-modal-sheet";
import "./inputVoice.css";
import { Loader } from "rsuite";


const InputVoiceSubmit = ({ onNavigateForward, loading }) => {
  const [isOpen, setOpen] = useState(false);
  const [isAnalyzing, setAnalyzing] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const contentRef = useRef(null);

  return (
    <div className="input-voice-container-wrapper">
      {/* Контейнер с кнопками */}
      <div className="voice-navigation-container-submit" onClick={(e) => {
        console.log(e)
        e.stopPropagation();
      }}>
        <button className="navigation-button" onClick={onNavigateForward}>
          {
          loading ? <Loader size='sm' /> :
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="50" height="50" rx="25" fill="#17C653"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M33.0534 18.9385C33.4271 19.3122 33.4271 19.9181 33.0534 20.2918L24.2814 29.0637C23.9077 29.4374 23.3018 29.4374 22.9281 29.0637L16.9473 23.0829C16.5736 22.7092 16.5736 22.1033 16.9473 21.7296C17.321 21.3558 17.9269 21.3558 18.3006 21.7296L23.6048 27.0338L31.7001 18.9385C32.0738 18.5648 32.6797 18.5648 33.0534 18.9385Z" fill="white"/>
          </svg>}
        </button>
      </div>
    </div>
  );
};

export default InputVoiceSubmit;
